export const kProblems = [
  {
    id: 1,
    accepted: false,
    history: "You are given a simple undirected graph, consisting of 𝑛 vertices and 𝑚 edges. The vertices are numbered from 1 to 𝑛. The 𝑖-th vertex has a value 𝑎𝑖 written on it. You will be removing vertices from that graph. You are allowed to remove vertex 𝑖 only if its degree is equal to 𝑎𝑖. When a vertex is removed, all edges incident to it are also removed, thus, decreasing the degree of adjacent non-removed vertices. A valid sequence of removals is a permutation 𝑝1,𝑝2,…,𝑝𝑛 (1≤𝑝𝑖≤𝑛) such that the 𝑖-th vertex to be removed is 𝑝, and every removal is allowed. A pair (𝑥,𝑦) of vertices is nice if there exist two valid sequences of removals such that 𝑥 is removed before 𝑦 in one of them and 𝑦 is removed before 𝑥 in the other one. Count the number of nice pairs (𝑥,𝑦) such that 𝑥<𝑦",
    title: "Removal Sequences",
    topics: ["graphs"],
    url: "https://codeforces.com/problemset/problem/1795/G",
  },
  {
    id: 2,
    accepted: false,
    history: "Abraham fed up with seeing so too many AC's decided to make a problem difficult enough so no one is able to solve it, prove him is wrong. Given n positive integers order them as follows: If a has fewer divisors than b then a must go before b. If the numbers tie in number of divisors these should be ordered from highest to lowest.",
    title: "Orden raro por divisores hard",
    topics: ["number theory", "math"],
    url: "https://omegaup.com/arena/problem/Orden-raro-por-divisores-hard/",
  },
  {
    id: "f8VMv2S9Tp7enjWNslHW",
    accepted: false,
    history: "There are 𝑛 people that will participate in voting. Each person has exactly one vote. 𝑖 -th person has a team 𝑡𝑖 (1≤𝑡𝑖≤𝑛) where 𝑡𝑖=𝑡𝑗  means 𝑖, 𝑗 are in the same team. By the rules each person should vote for the person from the different team. Note that it automatically means that each person can't vote for himself. Each person knows the number of votes 𝑐𝑖 he wants to get. How many possible votings exists, such that each person will get the desired number of votes? Due to this number can be big, find it by modulo 998244353.",
    title: "Count Voting",
    topics: ["math"],
    url: "https://codeforces.com/problemset/problem/1799/G",
  },
  {
    id: "nwU7JHwBVFJLIeqgueDk",
    accepted: false,
    title: "Problem fake",
    history: "This is not a problem, no context provided",
    topics: ["greedy"],
    url: "fake.com",
  },
  {
    id: "13213",
    accepted: false,
    title: "Abraham y los pokemones",
    history: "Abraham el joven maestro Pokémon ha encontrado una refugio enorme que consiste de n recintos uno tras de otro en una línea. Hay exactamente 1 Pokémon de cada tipo en cada recinto, esto para evitar que se peleen, para facilitarlo cada tipo es representado por una letra mayúscula o minúscula.Abraham quiere convivir con todos los tipos de Pokémon, pero entrar a cada recinto cuesta 1 bitcoin y él no tiene tanto dinero :c, uno diría que basta con saber cuántos tipos diferentes de Pokémon hay para conocer el precio final; pero el refugio tiene planes diferentes y quiere lucrar con ellos, por eso una vez que entras a un",
    topics: ["greedy"],
    url: "fake.com",
  }
]


